import getNextUID from './getNextUID';
export function getTypeFactory(alias, defaults = {}, init = (value) => value) {
    return (props) => init(Object.assign(Object.assign({ id: getNextUID(), alias }, defaults), props));
}
